// extracted by mini-css-extract-plugin
export default {"disableBtn":"styles_disableBtn__Ptb5r","disableBtnContent":"styles_disableBtnContent__Tx4QR"};